export enum ExpressCheckoutEnums {
  applePayExpressEnabledOnCart = 'applePayExpressEnabledOnCart',
  googlePayExpressEnabledOnCart = 'googlePayExpressEnabledOnCart',
  paypalExpressEnabledOnCart = 'paypalExpressEnabledOnCart'
}
